(function () {
  'use strict';

  const BAR     = document.getElementById('sticky-buy-box');
  const SECTION = BAR?.dataset.sectionId;
  const TARGET  = document.getElementById('MainProduct-' + SECTION);

  if (!BAR || !TARGET) return;

  const buyButtonsEl =
    TARGET.querySelector('[id^="ProductSubmitButton"]') ||
    TARGET.querySelector('form[data-type="add-to-cart-form"]') ||
    TARGET.querySelector('.product-form__buttons') ||
    TARGET;

  const observer = new IntersectionObserver(
    ([entry]) => {
      const visible = !entry.isIntersecting;
      BAR.classList.toggle('is-visible', visible);
      BAR.setAttribute('aria-hidden', String(!visible));
    },
    { rootMargin: '0px', threshold: 0 }
  );
  observer.observe(buyButtonsEl);

  const stickySelect  = document.getElementById('sticky-buy-box-variant');
  const stickyPrice   = document.getElementById('sticky-buy-box-price');
  const stickyCompare = document.getElementById('sticky-buy-box-compare');
  const stickyBtn     = document.getElementById('sticky-buy-box-atc');
  const stickyBtnText = stickyBtn?.querySelector('.sticky-buy-box__atc-text');

  function getCurrentVariantId() {
    if (stickySelect && stickySelect.value && stickySelect.value !== 'undefined') {
      return parseInt(stickySelect.value, 10);
    }
    if (stickyBtn?.dataset.variantId) {
      return parseInt(stickyBtn.dataset.variantId, 10);
    }
    const mainInput = document.querySelector(
      'form[data-type="add-to-cart-form"] .product-variant-id,' +
      'form[data-type="add-to-cart-form"] input[name="id"]'
    );
    if (mainInput?.value) return parseInt(mainInput.value, 10);
    return null;
  }

  // Fetch the cart icon section separately and update the bubble
  function refreshCartIconBubble() {
    fetch('/cart?section_id=cart-icon-bubble', { credentials: 'same-origin' })
      .then((r) => r.text())
      .then((html) => {
        const cartIconEl = document.getElementById('cart-icon-bubble');
        if (!cartIconEl) return;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const section = parsed.querySelector('.shopify-section');
        cartIconEl.innerHTML = section ? section.innerHTML : html;
      })
      .catch((e) => console.warn('[sticky-buy-box] cart icon refresh failed:', e));
  }

  function showAddedFeedback() {
    if (!stickyBtn || !stickyBtnText) return;
    stickyBtn.classList.add('sticky-buy-box__atc--added');
    stickyBtnText.textContent = '\u2713 Added';
    setTimeout(() => {
      stickyBtn.classList.remove('sticky-buy-box__atc--added');
      stickyBtnText.textContent = stickyBtn.disabled ? 'Sold Out' : 'Add to Cart';
    }, 2000);
  }

  if (stickySelect && stickySelect.tagName === 'SELECT') {
    stickySelect.addEventListener('change', () => {
      const mainInput = document.querySelector(
        'form[data-type="add-to-cart-form"] .product-variant-id,' +
        'form[data-type="add-to-cart-form"] input[name="id"]'
      );
      if (mainInput) {
        mainInput.value = stickySelect.value;
        mainInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (stickyBtn) stickyBtn.dataset.variantId = stickySelect.value;
      updatePriceFromOption(stickySelect.options[stickySelect.selectedIndex]);
    });
  }

  if (window.subscribe && window.PUB_SUB_EVENTS) {
    window.subscribe(window.PUB_SUB_EVENTS.optionValueSelectionChange, () => {
      setTimeout(() => {
        const mainInput = document.querySelector(
          'form[data-type="add-to-cart-form"] .product-variant-id,' +
          'form[data-type="add-to-cart-form"] input[name="id"]'
        );
        if (!mainInput?.value) return;
        const variantId = parseInt(mainInput.value, 10);
        if (stickySelect && stickySelect.tagName === 'SELECT') stickySelect.value = variantId;
        if (stickyBtn) stickyBtn.dataset.variantId = variantId;
        const variantData = getVariantById(variantId);
        if (variantData) updateStickyFromVariant(variantData);
      }, 100);
    });
  }

  function updatePriceFromOption(option) {
    if (!option) return;
    const price = parseInt(option.dataset.price, 10);
    const comparePrice = parseInt(option.dataset.comparePrice, 10);
    const available = option.dataset.available === 'true';
    updateStickyFromVariant({ price, compare_at_price: comparePrice || null, available });
  }

  function updateStickyFromVariant(variant) {
    if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
    if (stickyCompare) {
      const hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (hasCompare) {
        stickyCompare.textContent = formatMoney(variant.compare_at_price);
        stickyCompare.classList.remove('sticky-buy-box__compare-price--hidden');
      } else {
        stickyCompare.textContent = '';
        stickyCompare.classList.add('sticky-buy-box__compare-price--hidden');
      }
    }
    if (stickyBtn && stickyBtnText) {
      stickyBtn.disabled = !variant.available;
      stickyBtnText.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    }
  }

  function getVariantById(id) {
    const scriptTag = document.querySelector(
      'script[type="application/json"][id*="product-json"], .js-product-json'
    );
    if (!scriptTag) return null;
    try {
      const product = JSON.parse(scriptTag.textContent);
      return product.variants?.find((v) => v.id === id) || null;
    } catch { return null; }
  }

  function formatMoney(cents) {
    if (!cents && cents !== 0) return '';
    return '\u00A3' + (cents / 100).toFixed(2);
  }

  if (stickyBtn) {
    stickyBtn.addEventListener('click', async () => {
      if (stickyBtn.disabled || stickyBtn.classList.contains('loading')) return;

      const variantId = getCurrentVariantId();
      if (!variantId || isNaN(variantId)) {
        console.warn('[sticky-buy-box] No valid variant ID found');
        return;
      }

      stickyBtn.classList.add('loading');
      stickyBtn.setAttribute('aria-disabled', 'true');

      try {
        // Simple clean add to cart — no sections param (avoids the HTML redirect bug)
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json',
          },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });

        const data = await res.json();

        if (data.status) {
          console.warn('[sticky-buy-box] Cart error:', data.description);
        } else {
          // 1. Refresh cart icon via separate section fetch
          refreshCartIconBubble();

          // 2. Show ✓ Added feedback
          showAddedFeedback();

          // 3. Fire pubsub so cart drawer/notification updates too
          if (window.publish && window.PUB_SUB_EVENTS?.cartUpdate) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
              source: 'sticky-buy-box',
              productVariantId: variantId,
              cartData: data,
            });
          }
        }
      } catch (err) {
        console.error('[sticky-buy-box] Fetch error:', err);
      } finally {
        stickyBtn.classList.remove('loading');
        stickyBtn.removeAttribute('aria-disabled');
      }
    });
  }

})();
